import {PopularBrand} from "components/general-settings/search-page/popular-brand/PopularBrand";
import {useFetch} from "services/useFetch";
import {useEffect, useState} from "react";
import {constructOptionsSelect} from "utils/utils";
import {API_SEARCH_PAGE} from "services/apiSearchPage";

export const PopularBrandContainer = ({searchPageDetail, onChangeForm, errorForm}) => {
    const dataBrand = {...searchPageDetail?.brand_data}
    const { fetching: getBrandList } = useFetch(API_SEARCH_PAGE.BRAND_LIST)
    const [optionsBrand, setOptionsBrand] = useState([])

    const onChangeBrand = (item) => {
        onChangeForm({ brand_data: { ...dataBrand, ...item } })
    }

    const onSearchBrand = (keyword) => {
        getBrandList({ search: keyword }).then((response) => {
            const newList = constructOptionsSelect(response?.data, 'name', 'id')
            setOptionsBrand(newList)
        })
    }

    useEffect(() => {
        onSearchBrand()
    }, [])

    const props = {
        dataBrand,
        onSearchBrand,
        optionsBrand,
        onChangeBrand,
        errorForm,
    }

    return (
        <PopularBrand {...props}/>
    )
}
